import { ComponentController as BpController } from '@rta/rta-blueprint-component';
import { KitchenDataIn } from '@rta/rta-blueprint-library';

export type SaveDirtyKitchenLocally = {
	kitchenId: string;
	blueprintId: string;
	customer: string;
	isNew: boolean;
	sourceVersion: number | null;
	data: KitchenDataIn;
};

export const saveDirtyKitchenLocally = (customerEmail: string | null, controller: BpController, save = true): SaveDirtyKitchenLocally | null => {
	const blueprintId = controller.blueprint?.id ?? controller.kitchen.context.blueprint?.id ?? null;

	if (!blueprintId) return null;

	controller.kitchen.isLocal = true;
	controller.kitchen.isTemp = false;

	const value2Save: SaveDirtyKitchenLocally = {
		kitchenId: controller.kitchen.id,
		blueprintId,
		customer: customerEmail ?? '',
		isNew: controller.kitchen.baseVersion === null,
		sourceVersion: controller.kitchen.baseVersion,
		data: controller.kitchen.serialize()
	};

	// console.log('saveDirtyKitchenLocally', { version: controller.kitchen.version, value2Save });
	// sometime we only want the payload
	if (save) localStorage.setItem(`autosave-${blueprintId}`, JSON.stringify(value2Save));
	controller.render();

	return value2Save;
};
